import { DataGridTypes } from 'devextreme-react/data-grid'
import notify from 'devextreme/ui/notify'

export type PendingRow<T> = {
  data: Partial<T>
  // true se la riga è stata inserita o modificata nel batch corrente
  touched: boolean
}

/**
 * Applica le modifiche in sospeso di una griglia in modalità batch ai record letti dal server,
 * così da poter validare lo stato finale (es. univocità) prima del salvataggio.
 */
export const applyPendingChanges = <T extends { id: number }>(
  rows: T[],
  changes: DataGridTypes.DataChange[],
): PendingRow<T>[] => {
  const result = new Map<unknown, PendingRow<T>>(rows.map((row) => [row.id, { data: row, touched: false }]))
  for (const change of changes) {
    if (change.type === 'remove') {
      result.delete(change.key)
    } else if (change.type === 'update') {
      result.set(change.key, { data: { ...result.get(change.key)?.data, ...change.data }, touched: true })
    } else {
      result.set(change.key, { data: change.data, touched: true })
    }
  }
  return [...result.values()]
}

export const notifyError = (message: string) => {
  notify(
    {
      message,
      type: 'error',
      displayTime: 6000,
    },
    {
      position: 'bottom center',
      direction: 'up-push',
    },
  )
}

export const notifySuccess = (operation: string) => {
  notify(
    {
      message: `Operation successful: ${operation}`,
      type: 'success',
      displayTime: 3000,
    },
    {
      position: 'bottom center',
      direction: 'up-push',
    },
  )
}

/**
 * Esegue la validazione asincrona prima del salvataggio batch: se restituisce un messaggio,
 * il salvataggio viene annullato e il messaggio mostrato all'utente.
 */
export const validateBeforeSaving = (e: DataGridTypes.SavingEvent, validate: () => Promise<string | undefined>) => {
  if (e.changes.length === 0) return
  e.promise = validate()
    .then((error) => {
      if (error) {
        notifyError(error)
        e.cancel = true
      }
    })
    .catch((error: unknown) => {
      notifyError(`Errore durante la validazione: ${String(error)}`)
      e.cancel = true
    })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const storeErrorHandler = (e: any) => {
  console.error(e.errorDetails)
  if (!e.errorDetails) return
  notifyError(`Errore : ${e.errorDetails?.message}`)
}
